import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {reaction, autorun} from 'mobx';
import Autocomplete from 'react-google-autocomplete';
import * as moment from 'moment';

@inject ('RootStore')
@observer class AutocompleteApp extends Component {


  //General Constructor Function
  constructor(props) {
    super(props);
    this.getPollingPlace = this.getPollingPlace.bind(this);
  }

  formatAddressInfo =(place)=>{
    const {RootStore} = this.props;
    let address = encodeURI(place.formatted_address);
    let lat = place.geometry.location.lat();
    let lng = place.geometry.location.lng();

    console.log(place);

    setTimeout(function(){
      RootStore.globalPropsStore.updateGlobalProp('address', address);
      RootStore.globalPropsStore.updateGlobalProp('lat', lat);
      RootStore.globalPropsStore.updateGlobalProp('lng', lng);
      RootStore.globalPropsStore.getPollingElections();
    },200);
  }

  getPollingPlace = (e)=>{
    const {RootStore} = this.props;
    let eid = e.currentTarget.dataset.id;
    console.log(`Election ID: ${eid}`);
    RootStore.globalPropsStore.updateGlobalProp('eid', eid);
    setTimeout(function(){
      RootStore.globalPropsStore.getPollingLocations();
    },200);
    e.preventDefault();
  }

  //Render Function
  render() {
    //Pull the root store from application props
    const {RootStore} = this.props;

    //Scope of this for closures
    const _this = this;

    //Return all
    return (
      <>
      <Autocomplete style={{width: '100%'}} onPlaceSelected={(place) => { this.formatAddressInfo(place) }} types={['geocode']} componentRestrictions={{country: "us"}} placeholder="your registered voting address" />
      <div>
        {RootStore.globalPropsStore.pollingElections.length > 0 &&
          <>
          <h4>Choose Your Election:</h4>
          {RootStore.globalPropsStore.pollingElections.map((election, index) => (
            <li key={index}><a href="#" data-id={election.id} onClick={this.getPollingPlace}><strong>{election.name}:</strong> {moment(election.election_day).format('MMM Do YYYY')}</a></li>
          ))}
          </>
        }
      </div>
      </>
    );
  }

}

export default AutocompleteApp;
